<app-simple-grid
  [items]="attributes"
  gridControlName="attributes-list"
>
  <ng-template
    let-pageItems
    let-gridControl="gridControl"
  >
    <app-table
      [appRowActions]="attributesActions"
      [gridControl]="gridControl"
      [value]="pageItems"
    >
      <tr
        *appRowDef="let item"
        appRow
        class="active-row"
      ></tr>
      <ng-template
        [header]="'library.user_card.attributes.show.header' | translate"
        appColumn="show"
        let-item
        size="100px"
      >
        <app-input-switch
          [attr.data-qa]="'is-attribute-visible-' + item.key"
          [formControl]="item.isVisibleControl"
          [appTooltip]="'library.user_card.attributes.show.switch_tooltip' | translate"
        >
        </app-input-switch>
      </ng-template>
      <ng-template
        [header]="'library.user_card.attributes.display_name.header' | translate"
        appColumn="displayName"
        let-item
        size="2"
      >
        <span class="attribute-display-name">
          @if (item.displayNameKey) {
            {{ item.displayNameKey | translate }}
          }
          @if (!item.displayNameKey && item.type !== AttributeType.LDAP) {
            {{ item.displayName | default: '-' }}
          }
          @if (item?.source) {
            <app-link [source]="item?.source">
              <ng-template appTemplate="label">{{ item.displayName | default: '-' }}</ng-template>
            </app-link>
          }
        </span>
      </ng-template>
      <ng-template
        [header]="'library.user_card.attributes.key.header' | translate"
        appColumn="key"
        let-item
        size="2"
      >
        <div class="attribute-with-copy">
          <app-ellipsis>{{ item.keyWithBrackets }}</app-ellipsis>
          <app-copy-to-clipboard-button
            [textToCopy]="item.keyWithBrackets"
            class="item-actions"
          ></app-copy-to-clipboard-button>
        </div>
      </ng-template>
      <ng-template
        [header]="'library.user_card.attributes.value.header' | translate"
        appColumn="value"
        let-item
        size="3"
      >
        <div class="attribute-with-copy">
          <app-ellipsis>{{ item.value | default: '-' }}</app-ellipsis>
          <app-copy-to-clipboard-button
            [hidden]="!item.value"
            [textToCopy]="item.value"
            class="item-actions"
          ></app-copy-to-clipboard-button>
        </div>
      </ng-template>
    </app-table>
  </ng-template>
</app-simple-grid>
